
import React from "react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const UserProfilePostSkeleton = () => {
  return (
    <Card className="overflow-hidden border shadow-sm">
      <CardHeader className="bg-muted/30 py-3 px-4">
        <div className="flex items-center gap-2">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="space-y-1">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3 w-24" />
          </div>
        </div>
      </CardHeader>
      
      <CardContent className="pt-3 px-4">
        <Skeleton className="h-4 w-full mb-1" />
        <Skeleton className="h-4 w-[80%] mb-1" />
        <Skeleton className="h-4 w-[60%]" />
        
        <div className="mt-3">
          <Skeleton className="h-[200px] w-full rounded-md" />
        </div>
      </CardContent>
      
      <CardFooter className="flex pt-0 px-4 pb-3">
        <div className="flex items-center gap-4 pt-2">
          <Skeleton className="h-8 w-16" />
          <Skeleton className="h-8 w-16" />
          <Skeleton className="h-8 w-12" />
        </div>
      </CardFooter>
    </Card>
  );
};

export default UserProfilePostSkeleton;
